import presentation from '../constants/studioPresentation.json';

export const DOS_THEME = presentation.themes.dos;
export const MODERN_THEME = presentation.themes.modern;

// 테마 맵핑
export const THEME_MAP = {
  'dos': DOS_THEME,
  'modern': MODERN_THEME
};

// CSS 변수로 테마 적용
export const applyThemeToCSS = (theme) => {
  const root = document.documentElement;
  const themeData = THEME_MAP[theme] || MODERN_THEME;

  root.style.setProperty('--active-color', themeData.activeColor);
  root.style.setProperty('--inactive-color', themeData.inactiveColor);
  root.style.setProperty('--background-color', themeData.backgroundColor);
  root.style.setProperty('--border-color', themeData.borderColor);
  root.style.setProperty('--inactive-border-color', themeData.inactiveBorderColor);

  // 모달 배경색 설정
  const modalBgColor = theme === 'dos' ? '#000080' : '#ffffff';
  root.style.setProperty('--modal-background-color', modalBgColor);
};

// 테마 선택 함수 (기존 호환성 유지)
export const getThemeForPage = (pathname) => {
  // 현재 선택된 테마 확인
  const currentTheme = document.documentElement.getAttribute('data-theme') || 'modern';
  return THEME_MAP[currentTheme] || MODERN_THEME;
};
